export const getNotificationBarSettings = () => {
  const settingsToGet = ['notificationMessageTimestamp', 'notificationMessage', 'showNotificationMessage'];
  return settingsToGet
    .map(setting => {
      return `settings=${setting}`;
    })
    .join('&');
};
